export default __webpack_public_path__ + "static/media/spheres-other.36add928.mp3";